import { appNavItem } from '@armor/material';

export const APP_NAV_ITEMS: appNavItem[] = [
  {
    label: 'Design',
    items: [
      {
        label: 'Color',
        route: ['design/color'],
        keywords: ['primary', 'CTA', 'hex', 'accent', 'brand'],
      },
    ],
  },
  {
    label: 'Develop',
    items: [
      {
        label: 'CSS',
        route: ['develop/css'],
        keywords: ['CSS', 'utility'],
      },
    ],
  },
  {
    label: 'Components',
    items: [
      {
        label: 'Banner',
        route: ['components/banner'],
      },
      {
        label: 'Button',
        route: ['components/button'],
        keywords: ['CTA', 'buttons', 'action', 'new'],
      },
      {
        label: 'Layout',
        route: ['components/layout'],
        items: [
          { label: 'Overview', route: ['components/layout'] },
          { label: 'Columns', route: ['components/layout/cols'] },
          { label: 'Rows', route: ['components/layout/rows'] },
          { label: 'Compose', route: ['components/layout/compose'] },
        ],
      },
    ],
  },
];
